import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useLayout5Theme } from './theme';
import { ScrollToTopButton } from './ScrollToTopButton';
import './styles.css';
import './mobile.css';

interface Layout5RootProps {
  children: ReactNode;
  className?: string;
  withHeader?: boolean;
}

export function Layout5Root({ children, className, withHeader }: Layout5RootProps) {
  const { themeStyle } = useLayout5Theme();

  return (
    <div
      className={cn(
        'layout-5 min-h-screen bg-[var(--wl5-bg)]',
        withHeader && 'layout-5-with-header',
        className
      )}
      style={themeStyle}
    >
      {children}
      <ScrollToTopButton />
    </div>
  );
}
